var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChipDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-885 -688)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    fill: "black",
    stroke: "black",
    transform: "translate(885 688)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "none",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "black",
    cx: 12,
    cy: 12,
    r: 11
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-418 490)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1311 206)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "white",
    strokeWidth: "2px",
    d: "M-8691.969,9571.867l8,8",
    transform: "translate(8691.969 -9571.867)"
  }))), /*#__PURE__*/React.createElement("path", {
    stroke: "white",
    strokeWidth: "2px",
    d: "M0,0,8,8",
    transform: "translate(901 696) rotate(90)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipDelete);
export default __webpack_public_path__ + "static/media/chip-delete.ed881668.svg";
export { ForwardRef as ReactComponent };